
import { useLoading } from '@/contexts/LoadingContext';
import { useCallback } from 'react';
import { useAbielAudio } from '@/components/audio/AbielAudioContext';

export const useAudioLoading = () => {
  const { setLoading, isLoading, getLoadingMessage } = useLoading();
  const { isPlaying, currentSessionId } = useAbielAudio();

  const setAudioLoading = useCallback((prayerId: string, loading: boolean, message?: string, action: 'play' | 'pause' | 'process' = 'play') => {
    console.log('🎵 [useAudioLoading] setAudioLoading called:', { prayerId, loading, message, action });
    
    const defaultMessages = {
      play: 'Preparing audio...',
      pause: 'Pausing audio...',
      process: 'Processing prayer audio...'
    };

    // Use custom message if provided, otherwise use default based on action
    const finalMessage = message || defaultMessages[action];
    const loadingKey = `audio-${prayerId}`;
    
    console.log('🎵 [useAudioLoading] Using loading key:', loadingKey);
    console.log('🎵 [useAudioLoading] Message will be:', finalMessage);

    setLoading(loadingKey, loading, finalMessage, 'audio');
  }, [setLoading]);

  const setAudioLoadingWithState = useCallback((prayerId: string, loading: boolean, message?: string) => {
    console.log('🎵 [useAudioLoading] setAudioLoadingWithState called:', { prayerId, loading, message, isPlaying, currentSessionId });
    
    const loadingKey = `audio-${prayerId}`;
    const prayerSessionId = `prayer_${prayerId}`;
    
    // Determine the right message based on current audio state
    let finalMessage = message;
    if (!finalMessage) {
      if (loading) {
        finalMessage = 'Processing prayer audio...';
      } else if (isPlaying && currentSessionId === prayerSessionId) {
        finalMessage = 'Audio playing...';
      } else if (!isPlaying && currentSessionId === prayerSessionId) {
        finalMessage = 'Audio paused...';
      } else {
        finalMessage = 'Audio ready';
      }
    }
    
    console.log('🎵 [useAudioLoading] Using loading key:', loadingKey);
    console.log('🎵 [useAudioLoading] Final message will be:', finalMessage);

    setLoading(loadingKey, loading, finalMessage, 'audio');
  }, [setLoading, isPlaying, currentSessionId]);

  const isAudioLoading = useCallback((prayerId: string) => {
    const loadingKey = `audio-${prayerId}`;
    const result = isLoading(loadingKey);
    console.log('🎵 [useAudioLoading] isAudioLoading check:', { prayerId, loadingKey, result });
    return result;
  }, [isLoading]);

  const getAudioLoadingMessage = useCallback((prayerId: string) => {
    const loadingKey = `audio-${prayerId}`;
    const message = getLoadingMessage(loadingKey);
    console.log('🎵 [useAudioLoading] getAudioLoadingMessage:', { prayerId, loadingKey, message });
    return message;
  }, [getLoadingMessage]);

  return {
    setAudioLoading,
    setAudioLoadingWithState,
    isAudioLoading,
    getAudioLoadingMessage
  };
};
